import React from 'react';
import clsx from 'clsx';

const ServicesContainer = ({
  children,
  className,
  narrow = false,
  wide = false,
  marginTop,
}) => {
  const containerClasses = clsx(
    'w-full lg:w-3/4 mx-auto px-5 md:px-4', // default padding and full width

    marginTop === 0 && 'mt-0',
  );

  return <div className={clsx(containerClasses, className)}>{children}</div>;
};

export default ServicesContainer;
